// extracted by mini-css-extract-plugin
export var container = "SaleItem-module--container--qM2Ds";
export var image = "SaleItem-module--image--oVzJo";
export var infoContainer = "SaleItem-module--infoContainer--WAC9B";